import { render, staticRenderFns } from "./CustomIndex.vue?vue&type=template&id=25f4519a&scoped=true&"
import script from "./CustomIndex.vue?vue&type=script&lang=js&"
export * from "./CustomIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomIndex.vue?vue&type=style&index=0&id=25f4519a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4519a",
  null
  
)

export default component.exports